<template>
  <div class="country-warpper">
    <div class="img-box">
      <img :src="countryImg" alt="" />
    </div>
    <div class="name-box" v-text="countryName"></div>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，球员图片
    countryImg: {
      type: String,
      default:
        'https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=2687177869,2330854646&fm=58&bpow=556&bpoh=804',
    },
    // 必传参数，球员号码
    countryName: {
      type: String,
      default: '波兰',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.country-warpper {
  width: 6.25vw;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .img-box {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 4.2vw;
    height: 2.8vw;
    font-size: 0;
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      /* border-radius: 50%; */
      object-fit: contain;
    }
  }
  .name-box {
    width: 100%;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor_main);
    margin-top: 0.833vw;
  }
}
</style>
